<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button v-if="addPower" type="primary" icon="el-icon-plus" size="small" @click="setAddAndModify(false)">新建广告主账号</el-button>
        </li>
        <li>
          <span>账号：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryUserName" @input="getList"></el-input>
        </li>
        <li>
          <span>广告主：</span>
          <el-select size="small" v-model="queryAdowner" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in adowner" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>状态：</span>
            <el-select size="small" v-model="queryStatus" @change="myOption.restStartPage();getList();">
              <el-option v-for="(item, index) in myOption.status" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="ListMain-table-expand">
              <el-form-item label="联系人">
                <span>{{ props.row.linkman }}</span>
              </el-form-item>
              <el-form-item label="联系电话">
                <span>{{ props.row.phone }}</span>
              </el-form-item>
              <el-form-item label="创建时间">
                <span>{{ props.row.createTime }}</span>
              </el-form-item>
              <el-form-item label="最后修改时间">
                <span>{{ props.row.updateTime }}</span>
              </el-form-item>
              <el-form-item label="修改人">
                <span>{{ props.row.modifier }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{ props.row.remark }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="广告主账号" min-width="150px"></el-table-column>
        <el-table-column prop="nickName" label="姓名" min-width="150px"></el-table-column>
        <el-table-column prop="roleInfoVo.roleName" label="角色" min-width="150px"></el-table-column>
        <el-table-column prop="advertiserName" label="广告主" min-width="150px"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="scope">
            <el-switch v-model="tableData[scope.$index].status" :disabled="!statusPower" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="setStatus(tableData[scope.$index])"></el-switch>
          </template>
        </el-table-column>
        <el-table-column v-if="deletePower || modifyPower" label="操作" min-width="150px">
          <template slot-scope="scope">
            <el-button v-if="modifyPower" type="text" size="small" @click="setAddAndModify(tableData[scope.$index])">修改</el-button>
            <el-button v-if="deletePower" type="text" size="small" style="color: #F56C6C" @click="setDelete(tableData[scope.$index])">删除</el-button>
            <el-button v-if="trusteeshipPower" type="text" size="small" style="color: #E6A23C" @click="trusteeshipLogin(tableData[scope.$index])">托管登录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'List',
  components: {
    Pagination
  },
  data () {
    return {
      isLoading: false,
      thisModule: [],
      tableData: [],
      addPower: false,
      deletePower: false,
      modifyPower: false,
      statusPower: false,
      trusteeshipPower: !!this.$store.state.user.info.isSspUser,
      queryStatus: '',
      queryUserName: '',
      queryAdowner: '',
      adowner: [{id: '', name: '不限'}]
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.user.children.adUser.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      let power = powers[100].powerValue
      // 新建
      if ((power & thisModule.add.power) === thisModule.add.power) {
        this.addPower = true
      }
      // 删除
      if ((power & thisModule.delete.power) === thisModule.delete.power) {
        this.deletePower = true
      }
      // 修改
      if ((power & thisModule.modify.power) === thisModule.modify.power) {
        this.modifyPower = true
      }
      // 启用/禁用
      if ((power & thisModule.status.power) === thisModule.status.power) {
        this.statusPower = true
      }
    })
    // 缓存模块配置
    this.thisModule = thisModule
    // 判断临时缓存是否存在
    this.myOption.getScreenData(this, 'screen-aduser')
    // 调用获取广告主列表
    this.getAdownerList()
    // 调用获取列表函数
    this.getList()
  },
  methods: {
    // 获取广告主列表
    getAdownerList () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.adowner,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = [{id: '', name: '不限'}]
          for (let val of res.data.data.data) {
            data.push({id: val.advertiserId, name: val.advertiserName})
          }
          this.adowner = data
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 获取列表
    getList () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.api,
        data: this.qs.stringify({
          advertiserId: this.queryAdowner,
          userName: this.queryUserName,
          status: this.queryStatus,
          startPage: this.$store.state.user.currentPage,
          pageSize: this.$store.state.user.pageSize
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.tableData = res.data.data.data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 新增和修改
    setAddAndModify (data) {
      if (data) {
        this.$store.dispatch('SetEditId', {id: data.userId, copy: false})
      }
      let param = {}
      if (this.queryUserName !== '') {
        param.queryUserName = this.queryUserName
      }
      if (this.queryStatus !== '') {
        param.queryStatus = this.queryStatus
      }
      if (this.$store.state.user.currentPage !== 1) {
        param.startPage = this.$store.state.user.currentPage
      }
      if (this.$store.state.user.pageSize !== 10) {
        param.startPage = this.$store.state.user.pageSize
      }
      if (Object.keys(param).length > 0) {
        window.sessionStorage.setItem('screen-aduser', JSON.stringify(param))
      }
      this.myOption.switchListAndEdit(this, false)
    },
    // 删除
    setDelete (param) {
      this.$confirm(`是否删除 "${param.userName}" 广告主账号`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.delete.id
          },
          url: this.myOption.requestUrl + this.thisModule.delete.api,
          data: this.qs.stringify({
            userIds: param.userId
          })
        }).then(res => {
          const code = res.data.code
          if (res.data.code === 200) {
            this.$message.success('删除广告主账号成功')
            this.getList()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      }).catch(() => {})
    },
    // 启用/禁用
    setStatus (param) {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.status.id
        },
        url: this.myOption.requestUrl + this.thisModule.status.api,
        data: this.qs.stringify({
          userId: param.userId,
          status: param.status
        })
      }).then(res => {
        const code = res.data.code
        if (res.data.code === 200) {
          this.$message.success(`${param.status === 1 ? '启用' : '禁用'}广告主账号成功`)
        } else {
          this.myOption.abnormalCode(this, code)
          param.status = !param.status
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        param.status = !param.status
      })
    },
    // 托管登录
    trusteeshipLogin (param) {
      this.$confirm(`是否托管登录用户：${param.userName}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token
          },
          url: this.myOption.requestUrl + this.myOption.trusteeshipApi,
          data: this.qs.stringify({
            userId: param.userId
          })
        }).then((res) => {
          let code = res.data.code
          if (code === 200) {
            this.isLoading = false
            window.open(`${window.location.href.split('/home/')[0]}/jump?a=${window.btoa(unescape(encodeURIComponent(JSON.stringify({token: res.headers.authorization, info: res.data.data}))))}`)
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ad_user/List.vue